export const portfolioProjects = [
  {
    id: "studio-contabile",
    title: "Sito dinamico per studio contabile",
    desc: "Sito responsive con contenuti aggiornabili, CMS intuitivo e basi SEO on-page.",
    img: "/images/Portfolio/sito-studio-1280.webp",
    srcSet: "/images/Portfolio/sito-studio-640.webp 640w, /images/Portfolio/sito-studio-1280.webp 1280w",
    width: 1882, height: 919,
    link: "https://www.studioscarimbolo.it",
    cta: "Visita il sito",
    category: "Web",
    tags: ["CMS", "SEO", "Responsive"],
  },
  {
    id: "iot-vibrazioni",
    title: "Sistema IoT per controllo industriale",
    desc: "Tesi di laurea su sensori ESP32, dashboard ThingsBoard e manutenzione predittiva.",
    img: "/images/Portfolio/ESP32.webp",
    width: 486, height: 280,
    pdf: "/files/Tesi.pdf",
    cta: "Apri PDF",
    category: "IoT",
    tags: ["ESP32", "ThingsBoard", "Data"],
  },
  {
    id: "condomini-saas",
    title: "SaaS per la gestione dei condomini",
    desc: "In sviluppo: gestione di condomini, unità immobiliari e contabilità condominiale.",
    img: "/images/Portfolio/workinprogress.jpg",
    width: 256, height: 256,
    link: "https://github.com/alessandrosca2704/app-condomini",
    cta: "Segui lo sviluppo su GitHub",
    category: "Web App",
    tags: ["React", "TypeScript", "In sviluppo"],
  },
  {
    id: "scout-bari",
    title: "Sito vetrina per Gruppo Scout Bari 14",
    desc: "Sito responsive e aggiornabile, progettato per comunicare attivita e informazioni utili.",
    img: "/images/Portfolio/SitoSCOUT-1280.webp",
    srcSet: "/images/Portfolio/SitoSCOUT-640.webp 640w, /images/Portfolio/SitoSCOUT-1280.webp 1280w",
    width: 1920, height: 1080,
    link: "https://alessandrosca2704.wixsite.com/bari-14",
    cta: "Visita il sito",
    category: "Sito vetrina",
    tags: ["No-profit", "Responsive", "CMS"],
  },
];
